module.exports = __webpack_public_path__ + "img/workFlowYtg.360440e9.png";